import ActivityBlock from './ActivityBlock';
export default ActivityBlock;
